import { Prop } from "vue-property-decorator";
import i18n from "@/i18n";
import Vue from "vue";

export class DatePickerVue extends Vue {
  /** Флаг выбора пикера, по месацам false, по дням true */
  @Prop() isPeriodDate!: boolean;

  /** Первый год для списка годов */
  @Prop() startYear!: number;

  /** Последний год для списка годов */
  @Prop() endYear!: number;

  /** Изначальное значение */
  @Prop() defValue!: string;

  /** Значение для пероида */
  @Prop() months!: Array<any>;

  /** Нижняя граница */
  @Prop() minDate!: string;

  /** Верхняя граница */
  @Prop() maxDate!: string;

  @Prop() isShow!: boolean;

  /** Цвет пикера */

  @Prop() color!: string;

  /** Получение текста "Зкарыть" */
  getCloseText: Function = () => i18n.t("common.close");

  /** Получение текста "Ок" */
  getAcceptText: Function = () => i18n.t("common.accept");
}
